import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { faTrash} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'formly-repeat',
  template: `
    <div>
      <legend class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="props.label">{{ props.label }}</legend>
      <p *ngIf="props.description">{{ props.description }}</p>
      <div *ngFor="let field of field.fieldGroup; let i = index" class="mb-2">
        <div class="flex flex-row">
          <div *ngIf="!to['disableRemove']" class="basis-1/8">
          <button 
            class="text-red-500 grid"
            type="button"
            (click)="remove(i)">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
          </div>
          <formly-field
            class="w-full {{!to['disableRemove' ? 'basis-7/8' : 'basis-1/1']}}"
            [field]="field">
          </formly-field>
        </div>
      </div>

      <div style="margin:30px 0;" *ngIf="!to['disableAdd']">
        <button
          class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
          (click)="add()">
          Add {{ props.label }}
        </button>
      </div>
    </div>
  `,
})
export class RepeatComponent extends FieldArrayType {
  faTrash = faTrash;
  constructor() {
    super();
  }
}
